module.exports = __webpack_public_path__ + "img/s-sl-yy.f0907e80.png";